import { useEffect, useState } from 'react';

import NoSleepVideo from '~/assets/video/4hours.mp4';
import styles from './NoSleep.module.css';
import { holdScreenWakeLock, needsVideoUpFront } from './noSleepPolicy';

/**
 * This component is used to prevent the device from going into sleep mode.
 * Gamepad with reliable Wake Lock support: screen wake lock, the video only if
 * the request is refused. Elsewhere: a 4 hours video playing in the background
 * (looping the same video doesn't work on old versions of iOS).
 */
export function NoSleepView() {
    const [useVideo, setUseVideo] = useState(() =>
        needsVideoUpFront(
            window.location.pathname,
            'wakeLock' in navigator,
            navigator.userAgent,
            navigator.maxTouchPoints
        )
    );

    useEffect(() => {
        if (useVideo) return undefined;
        return holdScreenWakeLock(navigator.wakeLock, document, () => setUseVideo(true));
    }, [useVideo]);

    if (!useVideo) return null;
    return <video className={styles.video} src={NoSleepVideo} width="2" height="2" autoPlay playsInline muted />;
}
